import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Comment } from '../models/comment';
import { environment } from '../../environments/environment';
import { EnhancementFeedback } from '../models/enhancement-feedback';

@Injectable()
export class CommentService {

  baseUrl = environment.commentServiceBaseUrl;

  constructor(private http: HttpClient) {
  }

  createComment(comment: Comment) {
    const headers = new HttpHeaders()
      .set('Accept', 'application/json');
    const url = `${this.baseUrl}comment/`;
    return this.http.post<Comment>(url, comment, { headers });
  }

  getComment(commentId: string) {
    const url = `${this.baseUrl}comment/${commentId}`;
    const headers = new HttpHeaders()
      .set('Accept', 'application/json');
    return this.http.get<Comment>(url, { headers });
  }

  getComments(universalObjectString: string) {
    const url = `${this.baseUrl}comments/${universalObjectString}`;
    const headers = new HttpHeaders()
      .set('Accept', 'application/json');
    return this.http.get<Comment[]>(url, { headers });
  }

  submitEnhancementFeedback(enhancementFeedback: EnhancementFeedback) {
    const headers = new HttpHeaders()
      .set('Accept', 'application/json');
    const url = `${this.baseUrl}enhancement`;
    return this.http.post<void>(url, enhancementFeedback, {headers});
  }

   updateComment(commentId:string, comment: Comment){
    const headers = new HttpHeaders()
    .set('Accept', 'application/json');
    const url = `${this.baseUrl}comment/${commentId}`;
    return this.http.put<Comment>(url, comment, { headers });
   }

   deleteComment(commentId: string, userId: string) {
    const url = `${this.baseUrl}comment/${commentId}/${userId}`;
    const headers = new HttpHeaders()
      .set('Accept', 'application/json');
    return this.http.delete<void>(url, { headers });
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/api/services/comment.service.ts